<template>
  <div>
    <div id="collection" class="container">
      <section>
        <!-- 合集列表 -->
        <div class="collection-list section-group">
          <div class="row">
            <div class="col-12">
              <h2 class="section-title">{{$t('Album.VRanking.Ranking')}}</h2>
              <div class="row">
                <div class="col col-md-6 col-lg-4 col-xl-3 abc">
                  <div class="cards">
                    <div class="title">{{$t('Album.VRanking.Mostviewed')}}</div>
                    <div class="title_c">
                      <div></div>
                      <div>{{$t('Album.VRanking.Numberofclicks')}}</div>
                      <div>{{$t('Album.VRanking.photographer')}}</div>
                    </div>
                    <div class="column" v-for="(item, ix) in list1" :key="ix">
                      <div>
                        <div class="rank" :class="{ grayRank: ix > 2 }">
                          <span>{{ ix + 1 }}</span>
                        </div>
                      </div>
                      <div>{{ item.sgL_PG_CViewQuantityF }}</div>
                      <div
                        class="user"
                        @click="
                          $router.push({
                            name: 'customerPublishLook',
                            query: { authorId: item.sgl_mem_cid },
                          })
                        "
                      >
                        {{ item.sgL_Mem_DisplayName }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col col-md-6 col-lg-4 col-xl-3 abc">
                  <div class="cards">
                    <div class="title">{{$t('Album.VRanking.Mostuploaded')}}</div>
                    <div class="title_c">
                      <div></div>
                      <div>{{$t('Album.VRanking.Numberphotographs')}}</div>
                      <div>{{$t('Album.VRanking.photographer')}}</div>
                    </div>
                    <div class="column" v-for="(item, ix) in list2" :key="ix">
                      <div>
                        <div class="rank" :class="{ grayRank: ix > 2 }">
                          <span>{{ ix + 1 }}</span>
                        </div>
                      </div>
                      <div>{{ item.sgL_PG_CViewQuantityF }}</div>
                      <div
                        class="user"
                        @click="
                          $router.push({
                            name: 'customerPublishLook',
                            query: { authorId: item.sgl_mem_cid },
                          })
                        "
                      >
                        {{ item.sgL_Mem_DisplayName }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col col-md-6 col-lg-4 col-xl-3 abc">
                  <div class="cards">
                    <div class="title">{{$t('Album.VRanking.Mostdownloaded')}}
</div>
                    <div class="title_c">
                      <div></div>
                      <div>{{$t('Album.VRanking.Numberdownloads')}}
</div>
                      <div>{{$t('Album.VRanking.photographer')}}
</div>
                    </div>
                    <div class="column" v-for="(item, ix) in list3" :key="ix">
                      <div>
                        <div class="rank" :class="{ grayRank: ix > 2 }">
                          <span>{{ ix + 1 }}</span>
                        </div>
                      </div>
                      <div>{{ item.sgL_PG_CViewQuantityF }}</div>
                      <div
                        class="user"
                        @click="
                          $router.push({
                            name: 'customerPublishLook',
                            query: { authorId: item.sgl_mem_cid },
                          })
                        "
                      >
                        {{ item.sgL_Mem_DisplayName }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col col-md-6 col-lg-4 col-xl-3 abc">
                  <div class="cards">
                    <div class="title">{{$t('Album.VRanking.largestcollection')}}</div>
                    <div class="title_c">
                      <div></div>
                      <div>{{$t('Album.VRanking.collections')}}</div>
                      <div>{{$t('Album.VRanking.photographer')}}</div>
                    </div>
                    <div class="column" v-for="(item, ix) in list4" :key="ix">
                      <div>
                        <div class="rank" :class="{ grayRank: ix > 2 }">
                          <span>{{ ix + 1 }}</span>
                        </div>
                      </div>
                      <div>{{ item.sgL_PG_CViewQuantityF }}</div>
                      <div
                        class="user"
                        @click="
                          $router.push({
                            name: 'customerPublishLook',
                            query: { authorId: item.sgl_mem_cid },
                          })
                        "
                      >
                        {{ item.sgL_Mem_DisplayName }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /.合集列表 -->
      </section>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      list1: [],
      list2: [],
      list3: [],
      list4: [],
    };
  },
  created() {
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.$api.albumApi.GetVRanking(null).then((res) => {
        if (res.data.success) {
          this.list1 = res.data.result.filter(
            (c) => c.t === "SGL_PG_CViewQuantity"
          );
          this.list2 = res.data.result.filter((c) => c.t === "SGL_upload");
          this.list3 = res.data.result.filter((c) => c.t === "SGL_PG_Download");
          this.list4 = res.data.result.filter((c) => c.t === "SGL_PG_Favorite");
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
    },
  },
};
</script>

<style scoped>
.title {
  background-color: #31c66c;
  line-height: 42px;
  height: 42px;
  color: #fff;
  padding: 0 15px;
}
.title_c {
  display: flex;
  padding: 10px;
  background-color: #f2f2f2;
  color: #a3abaf;
}
.column {
  display: flex;
  align-content: center;
  padding: 10px;
  background-color: white;
  border-bottom: 1px solid #eaecf1;
}
.column a {
  color: #31c66c;
}
.title_c > div {
  padding: 0 15px;
}
.column > div {
  padding: 0 15px;
}
.rank {
  width: 25px;
  height: 25px;
  color: #31c66c;
  border: 2px solid #31c66c;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.grayRank {
  color: gray;
  border: 2px solid gray;
}
.rank > span {
  height: 25px;
  line-height: 25px;
}
.title_c > div:nth-child(1),
.column > div:nth-child(1) {
  width: 40px;
}
.title_c div:nth-child(2),
.column div:nth-child(2) {
  width: 120px;
  word-break: break-all;
  text-align: center;
}
.title_c div:nth-child(3),
.column div:nth-child(3) {
  width: 120px;
}

.user {
  color: #31c66c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user:hover {
  cursor: pointer;
}
.abc {
  min-width: 300px;
  padding: 10px;
  margin: 10px 0;
  box-sizing: border-box;
}
.cards {
  box-shadow: 1px 1px 1px 0 rgb(54 52 52 / 10%);
}
</style>


// WEBPACK FOOTER //
// src/components/Album/VRanking.vue